<template>
  <div>
    <el-drawer
      width="40%"
      title="发送配置"
      :visible.sync="selfVisible"
      :direction="direction"
      :before-close="handleClose"
      @open="handleOpen"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="110px"
        class="form"
      >
        <el-form-item
          v-for="(item,index) in rows.variableParam"
          :key="index"
          :label="item.length < 6 ? `${item} ：` : `${item.slice(0,6)} ：`"
          :prop="item"
        >
          <el-input v-model="form[item]"></el-input>
        </el-form-item>
        <el-form-item label="发送账户 ：" prop="phones">
          <el-select
            v-model="form.phones"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入手机号"
            :remote-method="remoteMethod"
            :loading="selectLoading"
            @change="handleChange"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.userName"
              :value="item.userName"
            ></el-option>
          </el-select>
          <span style="color:grey;margin-left:10px;">(输入手机号可进行搜索)</span>
        </el-form-item>
        <el-form-item class="submit">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="hanleSave('form')">发送</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>
<script>
import { getShopUserList } from '@/api/template';
import { validPhone } from '@/utils/validate';

export default {
  data() {
    return {
      selectLoading: false,
      selfVisible: false,
      rows: {},
      direction: 'rtl',
      options: [],
      form: {
        phones: [],
      },
      rules: {
        phones: [
          { required: true, message: '发送账户不能为空', trigger: 'change' },
        ],
      },
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    visible: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.selfVisible = newValue;
        }
      },
      immediate: true,
    },
    row: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.rows = newValue;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getShopUserList();
  },
  methods: {
    getShopUserList(query = '') {
      getShopUserList(query).then((res) => {
        if (res.success) {
          this.options = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    remoteMethod(query) {
      this.loading = true;
      if (validPhone(query) || query === '') {
        this.getShopUserList(query);
      }
    },
    handleChange() {
      this.getShopUserList();
    },
    handleOpen() {
      const { variableParam, id } = this.rows;
      this.form.id = id;
      variableParam.forEach((name) => {
        this.rules[name] = [
          { required: true, message: `${name}不能为空`, trigger: 'blur' },
        ];
        this.$set(this.form, name, '');
      });
    },
    hanleSave(formName) {
      const { phones, id, ...rest } = this.form;
      const remainParam = phones.map((item) => {
        const obj = this.options.find((items) => items.userName === item);
        if (obj) {
          return {
            ...rest,
            name: obj.userName,
            phone: obj.userPhone,
          };
        }
        return false;
      });
      const data = {
        id,
        param: remainParam,
      };
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('confirm', data);
          this.resetForm();
        }
        return false;
      });
    },
    handleClose() {
      this.$confirm('确认关闭？')
        .then(() => {
          this.$emit('close');
          this.resetForm();
        })
        .catch(() => {});
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
        this.form = {
          phones: [],
        };
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.form
  width 530px
  margin 0 auto
.submit
  text-align center
>>>.el-select__tags
  .el-select__input
    min-width 100%
</style>
